/** Photone Full + Red, 100 %, 27.09.2026. Avrundede snitt av loggede punkter. */
export const LYSPUNKTER = [
  { cm: 10, ppfd: 318 },
  { cm: 13.5, ppfd: 240 },
  { cm: 20, ppfd: 179 },
] as const;

export const standardAvstand = (potteId: string): number => potteId === 'potte1' ? 10 : 13.5;

/** Lineært mellom målepunktene. Utenfor målt område brukes nærmeste punkt. */
export function ppfdVedAvstand(cm: number, referansePpfd = 240): number {
  const avstand = Number.isFinite(cm) ? Math.max(10, Math.min(20, cm)) : 13.5;
  const [a, b] = avstand <= 13.5 ? [LYSPUNKTER[0], LYSPUNKTER[1]] : [LYSPUNKTER[1], LYSPUNKTER[2]];
  return Math.round((a.ppfd + (b.ppfd - a.ppfd) * (avstand - a.cm) / (b.cm - a.cm)) * referansePpfd / 240);
}

export function kassePpfd(potteId: string, avstander: Record<string, number>, referansePpfd: number): number {
  return ppfdVedAvstand(avstander[potteId] ?? standardAvstand(potteId), referansePpfd);
}
